export function reportError(error, errorInfo) {
  console.error(error, errorInfo);
  // Replace with a privacy-aware adapter for Sentry, Datadog, or another provider.
}
